/*
  For a query like
  "query GetFiles($folderId: ID $text: String $limit: Int $offset: Int $type: String $sort: String $dateRange: [String]) { getFiles(folderId: $folderId text: $text limit: $limit offset: $offset type: $type sort: $sort dateRange: $dateRange) { nodes { id name } } }";
  return getFiles as a topLevelQueryKey
  and ['folderId', 'text', 'limit', 'offset', 'type', 'sort', 'dateRange'] as allowedParams
*/
export function extractQueryDetails(query: string): {
  topLevelQueryKey: string;
  allowedParams: string[];
  searchTextParamName: string | null;
} {
  if (!query) {
    return {
      topLevelQueryKey: '',
      allowedParams: [],
      searchTextParamName: null,
    };
  }
  // Normalize the query to ensure consistent whitespace, but keep line breaks for parameter splitting
  const normalizedQuery = query.replace(/\s+/g, ' ');

  // Extract the entire block of parameters
  const parameterBlockMatch = normalizedQuery.match(/\((.*?)\)/s); // Using 's' flag for dotAll (match newline)
  let parameterBlock = parameterBlockMatch ? parameterBlockMatch[1] : '';

  const searchTextParamRegex = /text:\s*\$(\w+)/;
  const searchTextParamMatch = query.match(searchTextParamRegex);
  const searchTextParamName = searchTextParamMatch
    ? searchTextParamMatch[1]
    : null;

  // Correctly split the parameter block into individual parameters
  let allowedParams = [] as Array<string>;
  if (parameterBlock) {
    parameterBlock = parameterBlock.trimStart();
    // Split by line break or space followed by a dollar sign, considering GraphQL's structure
    allowedParams = parameterBlock
      .split(/\s+\$/)
      .map((param) => param.trim().split(':')[0].replace(/^\$/, ''));
    // // Remove empty strings
    // .filter((x) => x);
  }

  // Extract the top level query key
  const topLevelQueryKeyMatch = normalizedQuery.match(/{\s*(\w+)/);
  if (!topLevelQueryKeyMatch) {
    throw new Error('Top level query key not found.');
  }
  const topLevelQueryKey = topLevelQueryKeyMatch[1];

  return {
    topLevelQueryKey,
    allowedParams,
    searchTextParamName,
  };
}
